import React  from "react";
import ReactDOM  from "react-dom";
import App from "./calc";

ReactDOM.render(<App />, document.getElementById("root"));